import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';

const customLanguageDetector = {
  type: 'languageDetector',

  init: function (services, detectorOptions, i18nextOptions) {
    // Optional setup
  },

  detect: function () {
    // Detect language from URL
    if (typeof window !== 'undefined') {
      const pathname = window.location.pathname;
      const parts = pathname.split('/');
      const language = parts[1]; // e.g., /en/home → "en"
      if (language && ['ar', 'en'].includes(language)) {
        return language;
      } else {
        const savedLang = localStorage.getItem('i18nextLng');
        if (savedLang && ['ar', 'en'].includes(savedLang)) {
          return savedLang;
        }
      }
    }

    // Fallback
    return 'ar';
  },

  cacheUserLanguage: function (lng) {
    try {
      localStorage.setItem('i18nextLng', lng);
    } catch (e) {
      console.warn('Cannot cache language', e);
    }
  },
};

i18n
  .use(Backend)
  .use(customLanguageDetector) // register the fixed custom detector
  .use(initReactI18next)
  .init({
    fallbackLng: 'ar',
    debug: true,
    supportedLngs: ['ar', 'en'],
    ns: ['translation'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
  });

export default i18n;
